import { db } from '../utils/Database';

const tableNames = [
  'accounts', 'aiModels', 'aiPrompts', 'products', 'settings', 'settingTypes', 
  'contacts', 'locations', 'opportunities', 'quotes', 'quoteLines', 'bills', 'billLines'
];

/**
 * Service pour gérer les données de démo.
 */
class DemoDataService {
  /**
   * Vérifie si l'application est en mode démo.
   * @returns {boolean} True si en mode démo, sinon false.
   */
  isDemoMode() {
    return process.env.REACT_APP_IS_DEMO === 'true';
  }

  /**
   * Vérifie si la base de données est vide.
   * @returns {Promise<boolean>} True si la base de données est vide, sinon false.
   */
  async isDatabaseEmpty() {
    const accountsCount = await db.accounts.count();
    return accountsCount === 0;
  }

  /**
   * Peuple la base de données avec les données de démo si elle est vide et que l'app est en mode démo.
   */
  async populateDatabaseIfEmpty() {
    if (!this.isDemoMode()) {
      console.log("Application is in production mode. Skipping population.");
      return;
    }

    const isEmpty = await this.isDatabaseEmpty();
    if (!isEmpty) {
      console.log("Database is not empty. Skipping population.");
      return;
    }

    try {
      console.log("Application is in demo mode and database is empty. Populating with demo data...");
      const response = await fetch('/data/demo-data.json');
      if (!response.ok) {
        throw new Error(`Failed to fetch demo-data.json: ${response.statusText}`);
      }
      const data = await response.json();

      await db.transaction('rw', ...tableNames, async () => {
        // Clear all tables
        for (const tableName of tableNames) {
          if (db[tableName]) {
            await db[tableName].clear();
          }
        }
        console.log("All tables cleared.");

        // Populate all tables
        for (const tableName of tableNames) {
          if (data[tableName] && data[tableName].length > 0) {
            await db[tableName].bulkAdd(data[tableName]);
            console.log(`Populated ${tableName} with ${data[tableName].length} records.`);
          }
        }
      });

      console.log("Database populated successfully with demo data.");
    } catch (error) {
      console.error("Failed to populate database with demo data:", error);
    }
  }
}

const demoDataService = new DemoDataService();
export default demoDataService;
